
import Axios from 'axios';

async function getEnv() {
    try {  
        let resposta = await Axios.get(process.env.VUE_APP_BASE_URL + "env.json");
        return resposta.data;
    } catch (err) {
        return {};
    }
}

export { getEnv }

/*
async function getEnv() {
  try {
    let data = await fetch("/env.json", {
      mode: "no-cors",
    });
    return data.json();
  } catch (err) {
    console.log(err);
  }
}

export { getEnv }
*/